import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Button } from './ui';
import { useLocalePrice } from '../utils';

const StyledFileDemo = styled.article`
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: ${standardColours.white};
  border-radius: 30px;
  overflow: hidden;
`;

const StyledContent = styled.div`
  flex-grow: 1;
  display: grid;
  gap: 12px;
  padding: 30px;
`;

const StyledHeading = styled.h3`
  ${fontSize(17)};

  ${minBreakpointQuery.tsmall`
    ${fontSize(19)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(21)};
  `}
`;

const StyledPrice = styled.span`
  ${fontSize(14)};
  line-height: 1.5;
  font-weight: ${fontWeights.bold};

  ${minBreakpointQuery.tsmall`
    ${fontSize(15)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(16)};
  `}
`;

const StyledText = styled.p`
  ${fontSize(14)};
  line-height: 1.5;

  ${minBreakpointQuery.tsmall`
    ${fontSize(15)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(16)};
  `}
`;

const StyledButton = styled(Button)`
  margin-top: auto;
`;

const FileDemo = ({ image, heading, prices, text, file, ...props }) => {
  const localePrice = useLocalePrice(prices);

  return (
    <StyledFileDemo {...props}>
      <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />
      <StyledContent>
        <StyledHeading>{heading}</StyledHeading>
        {localePrice && <StyledPrice>{localePrice}</StyledPrice>}
        {text && <StyledText>{text}</StyledText>}
        <StyledButton to={file} download>
          See demo
        </StyledButton>
      </StyledContent>
    </StyledFileDemo>
  );
};

export default FileDemo;
